<template>
  <div class="d-flex justify-end align-center pr-4" style="width: 100%;">
    <v-menu
      offset-y
      left
      nudge-bottom="10"
      transition="slide-y-transition"
      content-class="custom-menu-content"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-avatar
          size="38"
          class="user-avatar-trigger"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="#de520c" size="22">mdi-account</v-icon>
        </v-avatar>
      </template>

          <v-card class="menu-card" elevation="10" width="280">
            <!-- Header Section -->
            <div class="menu-header d-flex flex-column align-center pt-6 pb-4 px-4">
              <div class="large-avatar mb-3 d-flex align-center justify-center">
                <v-icon color="#de520c" size="36">mdi-account-circle</v-icon>
              </div>
              <span class="welcome-text mb-1">Welcome</span>
              <span class="user-display-name text-truncate" v-if="appLogin">{{ appUser }}</span>
              <span class="user-display-role mt-1 text-truncate" v-if="appLogin && appUserrole">{{ appUserrole }}</span>
            </div>

            <v-divider class="mx-4"></v-divider>

            <!-- Menu Options -->
            <v-list dense class="py-2 px-2">
              <v-list-item
                v-if="appLogin"
                link
                :to="profilePath"
                class="menu-list-item py-1"
              >
                <v-list-item-icon class="mr-3 align-self-center my-0">
                  <v-icon size="20" color="#de520c">mdi-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title class="menu-item-title">My Profile</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Footer Section / Actions -->
            <div class="menu-footer px-4 pb-5 pt-2 d-flex justify-center">
              <v-btn
                v-if="!appLogin"
                block
                color="#de520c"
                depressed
                tile
                class="login-btn py-4"
                to="/login"
              >
                LOGIN
              </v-btn>
              <v-btn
                v-if="appLogin"
                block
                outlined
                class="logout-btn py-4"
                @click="appLogout"
              >
                LOGOUT
              </v-btn>
            </div>
          </v-card>
        </v-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },
    appUserrole() {
      return this.$store.state.userRole;
    },
    mainRole() {
      return this.$store.state.userRole;
    },
    profilePath() {
      const role = this.mainRole;
      if (role === 'admin') {
        return '/Admin/profile';
      } else if (['division', 'circle', 'range'].includes(role)) {
        return '/Officers/profile';
      } else if (role === 'MedicalOfficer') {
        return '/medicalOfficers/profile';
      } else if (role === 'District Emergency Officer') {
        return '/DistrictEmergencyOfficer/profile';
      }
      return '/login';
    }
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
  },
  sockets: {
    connect() {
      this.isConnected = true;
    },
    disconnect() {
      this.isConnected = false;
    },
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
};
</script>

<style scoped>
/* Activator avatar */
.user-avatar-trigger {
  background: rgba(222, 82, 12, 0.1) !important;
  border: 2px solid rgba(222, 82, 12, 0.2) !important;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.user-avatar-trigger:hover {
  background: rgba(222, 82, 12, 0.2) !important;
  border-color: rgba(222, 82, 12, 0.4) !important;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(222, 82, 12, 0.15);
}

/* Dropdown Menu Card */
.menu-card {
  border-radius: 16px !important;
  border: 1px solid rgba(222, 82, 12, 0.08) !important;
  overflow: hidden;
  background: #ffffff !important;
}
.menu-header {
  background: linear-gradient(180deg, #fffaf7 0%, #ffffff 100%);
}
.large-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(222, 82, 12, 0.08);
}
.welcome-text {
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.user-display-name {
  font-family: poppinssemibold, sans-serif;
  font-size: 17px;
  color: #0f172a;
  max-width: 100%;
}
.user-display-role {
  font-family: poppinsmedium, sans-serif;
  font-size: 11px;
  color: #de520c;
  background: rgba(222, 82, 12, 0.08);
  padding: 2px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  max-width: 100%;
}

/* Menu list options */
.menu-list-item {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}
.menu-list-item:hover {
  background: rgba(222, 82, 12, 0.05) !important;
}
.menu-item-title {
  font-family: poppinsmedium, sans-serif !important;
  font-size: 13px !important;
  color: #334155 !important;
  transition: color 0.3s ease;
}
.menu-list-item:hover .menu-item-title {
  color: #de520c !important;
}

/* Action Buttons */
.login-btn {
  font-family: poppinssemibold, sans-serif !important;
  font-size: 13px !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}
.login-btn:hover {
  background: #b83e05 !important;
  box-shadow: 0 4px 12px rgba(222, 82, 12, 0.25);
}
.logout-btn {
  font-family: poppinssemibold, sans-serif !important;
  font-size: 13px !important;
  color: #de520c !important;
  border: 1px solid rgba(222, 82, 12, 0.2) !important;
  border-radius: 8px !important;
  background: rgba(222, 82, 12, 0.02) !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
}
.logout-btn:hover {
  background: linear-gradient(135deg, #de520c, #b83e05) !important;
  color: #ffffff !important;
  border-color: transparent !important;
  box-shadow: 0 6px 16px rgba(222, 82, 12, 0.25);
}
</style>